export default input => input?.toLowerCase().replace(/[^:|\d|a-z]/g, '');